import accommodationList from './AccommodationList/pt.json';
import chat from './Chat/pt.json';
import common from './Common/pt.json';
import consent from './Consent/pt.json';
import forgotPassword from './ForgotPassword/pt.json';
import main from './Main/pt.json';
import signIn from './SignIn/pt.json';
import signUp from './SignUp/pt.json';
import transportList from './TransportList/pt.json';

export default {
  accommodationList,
  chat,
  common,
  consent,
  forgotPassword,
  signIn,
  signUp,
  transportList,
  main
};
